import { render, staticRenderFns } from "./RadioResidentExt.vue?vue&type=template&id=08a6d19f&lang=pug"
import script from "./RadioResidentExt.vue?vue&type=script&lang=js"
export * from "./RadioResidentExt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports